import React, { useEffect, useState } from "react";
import { getObligationsForAgreement } from "../apis/obligationApi";
import { Button, Checkbox, Text } from "@mantine/core";
import UniversalTable from "./Common/UniversalTable";
import { getActFrequencyText, getDepartmentText } from "../pages/utilities";

const MasterObForAgreement = ({
  local,
  agreementId,
  onSelectOb,
  createNewObligation,
  dependedOb,
}) => {
  const [obligations, setObligations] = useState(null);
  const getMasterObligationsforAgreement = async () => {
    const response = await getObligationsForAgreement({
      local: local,
      agreementId: agreementId,
    });
    console.log(response);
    setObligations(response.obligations);
  };
  useEffect(() => {
    getMasterObligationsforAgreement();
  }, []);
  return (
    <div>
      <UniversalTable
            headers={[
              {
                label: "obligation id (m)",
                align: "center",
                render: (row) => <Text size="xs">{row.id}</Text>,
              },
              {
                label: "obligation title",
                align: "center",
                render: (row) => <Text size="xs" weight={600}>{row.title}</Text>,
              },
              {
                label: "description",
                align: "center",
                render: (row) => <Text size="xs">{row.desc}</Text>,
              },
              {
                label: "act. frequency",
                align: "center",
                render: (row) => <Text size="xs">{getActFrequencyText(row.actFrequency)}</Text>,
              },
              {
                label: "department",
                align: "center",
                render: (row) => <Text size="xs">{getDepartmentText(row.department)}</Text>,
              },
              {
                label: "assigned to",
                align: "center",
                render: (row) => <Text size="xs">{row.assignTo?.name || "--"}</Text>,
              },
              {
                label: "select",
                align: "center",
                render: (row) => (
                  <Checkbox
                    disabled={row.dependedOb}
                    checked={dependedOb && dependedOb === row.id}
                    onChange={() => onSelectOb(row.id)}
                  />
                ),
              },
            ]}
            data={obligations || []}
            loading={false}
            emptyMessage="No obligations found"
          />
      <div className="mt-4 flex  justify-end">
        <Button
          disabled={!dependedOb}
          onClick={(e) => createNewObligation(e)}
        >
          Connect
        </Button>
      </div>
    </div>
  );
};

export default MasterObForAgreement;
